// ResetPasswordPage.tsx

import React from 'react';
import styled from 'styled-components';
import { Form, Input, Button, Typography, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { resetPassword } from '../signin/authservice';

const { Title, Text } = Typography;

const Container = styled.div`
  display: flex;
  min-height: calc(100vh - 4rem);
  padding: 2rem;
  align-items: center;
  justify-content: center;
  background-color: #f4f6fb;
`;

const ResetSection = styled.div`
  max-width: 400px;
  padding: 2rem;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledButton = styled(Button)`
  width: 100%;
  padding: 0.75rem;
  font-weight: bold;
  border-radius: 8px;
  margin-top: 1rem;
`;

const ResetPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get('token');
  if (!token) {
    message.error('Invalid or missing token');
    navigate('/signin');
    return null;
  }

  const onFinish = async (values: any) => {
    const { newPassword, confirmPassword } = values;
    try {
      // Call the resetPassword service function
      await resetPassword(newPassword, token);

      message.success('Password reset successfully!');
      // Redirect user or take any other action
      navigate('/signin');
    } catch (error: any) {
      message.error(error.message);
      console.error('Error resetting password:', error);
    }
  };

  return (
    <Container>
      <ResetSection>
        <Title level={2}>Reset Password</Title>
        <Text type="secondary">
          Enter your new password below to reset it
        </Text>

        <Form
          name="resetPassword"
          layout="vertical"
          onFinish={onFinish}
          style={{ width: '100%', marginTop: '1.5rem' }}
        >
          <Form.Item
            label="New Password"
            name="newPassword"
            rules={[
              { required: true, message: 'Please enter your new password!' },
              { min: 6, message: 'Password must be at least 6 characters.' },
            ]}
          >
            <Input.Password placeholder="New Password" />
          </Form.Item>

          <Form.Item
            label="Confirm Password"
            name="confirmPassword"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: 'Please confirm your new password!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error('Passwords do not match!')
                  );
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm Password" />
          </Form.Item>

          <StyledButton type="primary" htmlType="submit">
            Reset Password
          </StyledButton>
        </Form>
      </ResetSection>
    </Container>
  );
};

export default ResetPasswordPage;
